const ContactBody = () => {

  return (
    <div style={{
      position: 'relative',
      padding: '56px',
      backgroundColor: '#1a1a1a',
      borderBottom: '16px solid #1a1a1a',
      borderRadius: '0px 0px 16px 16px',
      zIndex: '2',
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <h2 style={{ 
                color: 'white',
                fontSize: 'clamp(24px, 2.5vw, 2.5vw)',
                fontWeight: '400',
                lineHeight: '1.2',
                margin: '0'
              }}>
                Contact us
              </h2>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                Hello there! We're delighted to be your go-to contacts for any questions, 
                concerns, or just a friendly chat. At Verumus, we understand that 
                life doesn't always stick to a 9-to-5 schedule, so neither do we! Our team is 
                here for you 24/7, ready to assist and ensure your experience with us is as 
                smooth as possible. Whether you prefer a call, email, or reaching out through 
                our socials, we're just a message away. Your satisfaction is our top priority, 
                and we can't wait to connect with you whenever you need us. Cheers to building 
                a fantastic relationship together!
              </p>
              <div style={{ marginTop: '16px' }}>
                  <ul style={{ 
                    listStyle: 'none',
                    padding: '0',
                    margin: '0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                  }}>
                    <li style={{ fontSize: 'clamp(16px, 1.8vw, 1.8vw)', fontWeight: '300' }}>
                      <a 
                        href="https://wa.me/+15513732595" 
                        target="_blank" 
                        style={{ 
                          color: 'white', 
                          textDecoration: 'none',
                          transition: 'color 0.2s ease, transform 0.2s ease',
                          display: 'inline-block',
                          padding: '4px 12px',
                          borderRadius: '8px',
                          backgroundColor: 'transparent',
                          border: '1px solid transparent'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = '#c8dafb';
                          e.target.style.transform = 'translateX(5px)';
                          e.target.style.borderColor = '#c8dafb';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = 'white';
                          e.target.style.transform = 'translateX(0)';
                          e.target.style.borderColor = 'transparent';
                        }}
                      >
                        Whatsapp
                      </a>
                    </li>
                    <li style={{ fontSize: 'clamp(16px, 1.8vw, 1.8vw)', fontWeight: '300' }}>
                      <a 
                        href="https://t.me/verumus" 
                        target="_blank" 
                        style={{ 
                          color: 'white', 
                          textDecoration: 'none',
                          transition: 'color 0.2s ease, transform 0.2s ease',
                          display: 'inline-block',
                          padding: '4px 12px',
                          borderRadius: '8px',
                          backgroundColor: 'transparent',
                          border: '1px solid transparent'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = '#c8dafb';
                          e.target.style.transform = 'translateX(5px)';
                          e.target.style.borderColor = '#c8dafb';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = 'white';
                          e.target.style.transform = 'translateX(0)';
                          e.target.style.borderColor = 'transparent';
                        }}
                      >
                        Telegram
                      </a>
                    </li>
                    <li style={{ color: 'white', paddingLeft: '12px', fontSize: 'clamp(16px, 1.8vw, 1.8vw)', fontWeight: '300' }}>
                      Phone number: 
                      <a 
                        href="tel:+15513732595" 
                        target="_blank" 
                        style={{ 
                          color: 'white', 
                          textDecoration: 'none',
                          transition: 'color 0.2s ease, transform 0.2s ease',
                          display: 'inline-block',
                          padding: '4px 12px',
                          borderRadius: '8px',
                          backgroundColor: 'transparent',
                          border: '1px solid transparent',
                          marginLeft: '4px'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = '#c8dafb';
                          e.target.style.transform = 'translateX(5px)';
                          e.target.style.borderColor = '#c8dafb';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = 'white';
                          e.target.style.transform = 'translateX(0)';
                          e.target.style.borderColor = 'transparent';
                        }}
                      >
                        +1 (551) 373-2595
                      </a>
                    </li>
                    <li style={{ color: 'white', paddingLeft: '12px', fontSize: 'clamp(16px, 1.8vw, 1.8vw)', fontWeight: '300' }}>
                      E-mail: 
                      <a 
                        href="mailto:info@bylobyte.com" 
                        target="_blank" 
                        style={{ 
                          color: 'white', 
                          textDecoration: 'none',
                          transition: 'color 0.2s ease, transform 0.2s ease',
                          display: 'inline-block',
                          padding: '4px 12px',
                          borderRadius: '8px',
                          backgroundColor: 'transparent',
                          border: '1px solid transparent',
                          marginLeft: '4px'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = '#c8dafb';
                          e.target.style.transform = 'translateX(5px)';
                          e.target.style.borderColor = '#c8dafb';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = 'white';
                          e.target.style.transform = 'translateX(0)';
                          e.target.style.borderColor = 'transparent';
                        }}
                      >
                        info@bylobyte.com
                      </a>
                    </li>
                  </ul>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <h2 style={{ 
                color: 'white',
                fontSize: 'clamp(24px, 2.5vw, 2.5vw)',
                fontWeight: '400',
                lineHeight: '1.2',
                margin: '0'
              }}>
                Privacy
              </h2>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                Last updated: 01/28/2024
              </p>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                Verumus LLC (Operating as "ByloByte") ("us", "we", or "our") operates the 
                Dyno Bulk Discount Codes app (the "Service") on the Shopify platform.
                This Privacy Policy outlines our practices regarding the collection,
                use, and safeguarding of information when you utilize our Service.
                We are committed to protecting your privacy and ensuring transparent
                data handling practices.
              </p>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                We maintain strict confidentiality of your information and only process it
                as specified within this Privacy Policy. Your trust is paramount to us.
              </p>
              <h2 style={{ 
                color: 'white',
                fontSize: 'clamp(20px, 2vw, 2vw)',
                fontWeight: '400',
                lineHeight: '1.2',
                margin: '16px 0 0 0'
              }}>
                Information Collection and Use
              </h2>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
              For the operation of our Service, we collect and maintain the following essential data:
              </p>
              <ul style={{ 
                listStyle: 'disc',
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0',
                paddingLeft: '24px'
              }}>
                <li>Shopify store information</li>
                <li>Email address (for communication purposes)</li>
                <li>Discount-related data:
                  <ul style={{ marginTop: '8px' }}>
                    <li>Discount identifiers and titles</li>
                    <li>Number of discount codes requested and generated</li>
                    <li>Generation status and timestamps</li>
                  </ul>
                </li>
              </ul>
              <p style={{ 
                color: '#151515',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '400',
                lineHeight: '1.5',
                margin: '16px 0',
                padding: '16px',
                border: '1px solidrgb(156, 191, 255)',
                borderRadius: '8px',
                backgroundColor: '#c8dafb'
              }}>
                We do not collect or store any customer data or order information from your Shopify store. 
                Our service operates solely with discount code management, ensuring your customers' privacy and data security.
              </p>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '16px 0 0 0'
              }}>
              Our application requires the following Shopify access permissions:
              </p>
              <ul style={{ 
                listStyle: 'disc',
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0',
                paddingLeft: '24px'
              }}>
                <li>read_products: Required for product and collection association with discounts</li>
                <li>read_discounts: Essential for discount code generation and management</li>
                <li>write_discounts: Necessary for creating and managing discount codes</li>
              </ul>
              <h2 style={{ 
                color: 'white',
                fontSize: 'clamp(20px, 2vw, 2vw)',
                fontWeight: '400',
                lineHeight: '1.2',
                margin: '16px 0 0 0'
              }}>
                Log Data
              </h2>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                In the course of providing our Service, we automatically collect certain diagnostic
                information ("Log Data"). This may include your device's Internet Protocol (IP) address,
                browser specifications, access timestamps, and interaction metrics. This information
                is essential for maintaining service quality and security.
              </p>
              <h2 style={{ 
                color: 'white',
                fontSize: 'clamp(20px, 2vw, 2vw)',
                fontWeight: '400',
                lineHeight: '1.2',
                margin: '16px 0 0 0'
              }}>
                Cookies
              </h2>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                Cookies are files with a small amount of data, which may include an anonymous unique 
                identifier. Cookies are sent to your browser from a website and stored on your 
                computer's hard drive.
              </p>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                We use "cookies" to collect information. You can instruct your browser to refuse all 
                cookies or to indicate when a cookie is being sent. However, if you do not accept cookies,
                you may not be able to use some portions of our Service.
              </p>
              <h2 style={{ 
                color: 'white',
                fontSize: 'clamp(20px, 2vw, 2vw)',
                fontWeight: '400',
                lineHeight: '1.2',
                margin: '16px 0 0 0'
              }}>
                Security
              </h2>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                We implement industry-standard security measures to protect your information.
                This includes encrypted data transmission, secure data storage, and regular
                security audits. While we employ best practices to safeguard your information,
                please note that no electronic transmission or storage method is entirely secure.
                We continuously monitor and update our security protocols to maintain data protection.
              </p>
              <h2 style={{ 
                color: 'white',
                fontSize: 'clamp(20px, 2vw, 2vw)',
                fontWeight: '400',
                lineHeight: '1.2',
                margin: '16px 0 0 0'
              }}>
                Changes to This Privacy Policy
              </h2>
              <p style={{ 
                color: '#888888',
                fontSize: 'clamp(16px, 1.8vw, 1.8vw)',
                fontWeight: '300',
                lineHeight: '1.5',
                margin: '0'
              }}>
                We reserve the right to update this Privacy Policy as needed. Any modifications
                will be effective immediately upon posting the updated version on this page.
                We encourage you to periodically review this Privacy Policy to stay informed
                about how we protect your information.
              </p>
            </div>
          </div>
        </div>
    </div>
  );
}

export default ContactBody;
